<template>
    <div class="l-edit-table" :style="{height:height}" :class="{fullscreen:isFullScreen}">
        <el-table
            :data="dataSourceShow"
            v-if="showTable"
            style="width: 100%"
            size = "mini"
            :height="height"
            :max-height="maxHeight"
            :header-cell-style="{padding:'4px 0'}"

            :stripe="stripe"
            :border="border"
            :fit="fit"
            :show-header="showHeader"
            :highlight-current-row="highlightCurrentRow"
            :current-row-key="currentRowKey"
            :row-key="rowKey"

            :row-class-name="rowClassName"
            :cell-class-name="cellClassName"
            :header-row-class-name="headerRowClassName"
            :header-cell-class-name="headerCellClassName"

            :default-expand-all="defaultExpandAll"
            :expand-row-keys="expandRowKeys"

            :default-sort="defaultSort"

            :tooltip-effect="tooltipEffect"

            :show-summary="showSummary"
            :sum-text="$t(sumText)"
            :summary-method="summaryMethod || getSummaryMethod"

            :span-method="spanMethod"

            :select-on-indeterminate="selectOnIndeterminate"

            :indent="indent"
            :lazy="lazy"
            :load="load"
            :tree-props="treeProps"

            @select="select"
            @select-all="selectAll"
            @selection-change="selectionChange"
            @cell-mouse-enter="cellMouseEnter"
            @cell-mouse-leave="cellMouseLeave"
            @cell-click="cellClick"
            @cell-dblclick="cellDblclick"
            @row-click="rowClick"
            @row-contextmenu="rowContextmenu"
            @row-dblclick="rowDblclick"
            @header-click="headerClick"
            @header-contextmenu="headerContextmenu"
            @sort-change="sortChange"
            @filter-change="filterChange"
            @current-change="currentChange"
            @header-dragend="headerDagend"
            @expand-change="expandChange"

            ref="learunTable"
            >
            <el-table-column
               v-if="!delMode"
              label="#"
              type="index"
              align="center"
              width="80px"
              :index="indexMethod"
              >
              <template #header>
                <div style="height: 25px;">
                  <div class="num-box">
                    <i class="el-icon-full-screen btn" :title="isFullScreen ? '退出全屏' : '全屏'" @click="isFullScreen = !isFullScreen"></i>
                    <i v-if="isRemoveBtn && !isRead" class="el-icon-delete btn" title="批量删除" @click="delMode = true"></i>
                  </div>
                  <div class="num-box-hide">
                    #
                  </div>
                </div>
                
              </template>
              <template v-slot="scope" >
                <div style="height: 25px;">
                  <div class="num-show">{{ scope.$index + 1}}</div>
                  <div class="num-hide">
                    <template v-if="!isRead">
                      <i class="el-icon-full-screen btn" @click.stop="toEdit(scope.$index, scope.row)"></i> 
                      <i class="el-icon-delete btn danger" v-if="isRemoveBtn" :title="$t('删除')" @click.stop="handleDelete(scope.$index, scope.row)"></i> 
                      <el-dropdown v-if="isAddBtn" @command="handleCommand" placement="bottom-start" trigger="click">
                        <span class="el-dropdown-link">
                          <i class="el-icon-more btn" style="transform: rotate(90deg);"></i> 
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item :command="{type: 'copyToNext',row: scope.row, index: scope.$index}">{{$t('复制到下一行')}}</el-dropdown-item>
                          <el-dropdown-item :command="{type: 'copyToLast',row: scope.row, index: scope.$index}">复制到最后一行</el-dropdown-item>
                          <el-dropdown-item v-if="insertLine" :command="{type: 'insertToPrev',row: scope.row, index: scope.$index}">向上插入行</el-dropdown-item>
                          <el-dropdown-item v-if="insertLine" :command="{type: 'insertToNext',row: scope.row, index: scope.$index}">向下插入行</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                    <span v-else>{{ scope.$index + 1}}</span>
                  </div>
                </div>
                  
              </template>
            </el-table-column>
            <el-table-column
              v-else
              align="center"
              type="selection"
              width="80px">
            </el-table-column>
            <template v-for="(col,index) in tableColumns" >
              <el-table-column
                :key="`${col.prop}${index}`"
                :prop="col.prop"
                :label="$t(col.label)"
                :align="col.align"
                :width="col.width"
                :min-width="col.minWidth"
                :header-align="col.headerAlign"
                v-if="!col.isHidden && !col.children"
                >
                <template
                  v-slot:header="{column}"
                >
                  <span v-if="isRequired(column.property)" style="color:red">*</span><span>{{$t(column.label)}}</span>
                </template>
                <template v-slot="scope" >
                  <slot v-bind="scope" :name="col.prop">{{scope.row[col.prop]}}</slot>
                </template>
              </el-table-column>
              <dynamic-column 
                v-else-if="!col.isHidden"
                :columnOption="col"  
                :isRequired="isRequired"
                :key="index"
                :label="$t(col.label)"
                :allProps="col.props"
                >
                <template v-for="myProp in col.props || []"  v-slot:[myProp]="scope">
                  <slot v-bind="scope" :name="myProp"></slot>
                </template>
              </dynamic-column>
              
            </template>

            <slot></slot>
            <el-table-column v-if="isDetailBtn && !printMode" align="center" width="60" >
                <template slot-scope="scope">
                  <!-- class="el-button el-button--text el-button--mini" -->
                    <el-button
                        type="text"
                        @click.stop="handleDetail(scope.$index, scope.row)"
                        >
                        {{$t('详情')}}
                    </el-button>
                </template>
            </el-table-column>
            <!-- <el-table-column v-if="isRemoveBtn && !isRead" align="center" width="40" >
                <template slot-scope="scope">
                    <button
                        v-if="hasDeleteBtn(scope.row)"
                        style="color: #f56c6c;"
                        type="button"
                        @click.stop="handleDelete(scope.$index, scope.row)"
                        class="el-button el-button--text el-button--mini">
                        <i class="el-icon-delete"></i>
                    </button>
                </template>
            </el-table-column> -->
        </el-table>
        <div v-if="delMode" class="l-edit-table--addbtn" style="border: none;text-align: left;padding-left: 12px;">
            <el-button size="mini" @click="delMode = false;selected=[]">取消操作</el-button>
            <el-button type="danger" :disabled="selected.length ? false : true" size="mini" @click="delSelected">删除选中</el-button>
        </div>
        <div v-else-if="isAddBtn && !isRead" class="l-edit-table--addbtn" style="border: none;text-align: left;padding-left: 12px;">
            <el-button type="text" style="font-size: 14px;" size="mini" icon="el-icon-plus" @click="handleAdd">{{$t(addBtnText)}}</el-button>
            <el-button v-if="pasteAdd" type="text" style="font-size: 14px;" size="mini" icon="el-icon-edit-outline" @click="handlePasteAdd">{{$t('粘贴新增')}}</el-button>
        </div>
        <l-drawer :wrapperClosable="true" :visible.sync="visible" @ok="visible = false" :title="title" width="460px" :showClose="false" :okBtnLabel="$t('完成')">
          <template #topBtns>
            <div class="flex" style="white-space: nowrap;">
                <el-button type="text" @click="prev" :disabled="!activeIndex" :title="$t('上一条')" size="mini" icon="el-icon-arrow-left"></el-button>
                <span style="margin: 0 6px"><b>{{ activeIndex + 1 }}</b> / {{ dataSourceShow.length }}</span>
                <el-button type="text" @click="next" :disabled="activeIndex == (dataSourceShow.length - 1)" :title="$t('下一条')" size="mini" icon="el-icon-arrow-right"></el-button>
            </div>
            <el-divider direction="vertical"></el-divider>
          </template>
          <template #btns v-if="isAddBtn">
            <el-button size="mini" @click="addNewForm">{{$t('新增')}}</el-button>
            <el-button size="mini" @click="addCopyForm">{{$t('复制')}}</el-button>
          </template>
          <div style="height: 100%;overflow: auto;padding: 12px;">
            <el-form size="mini" v-if="dataSource[activeIndex]" :model="dataSource[activeIndex]" :rules="rules" ref="form" label-width="400px" label-position="top">
              <el-form-item v-for="(col,index) in tableColumns" :key="col.prop" :label="col.label" :prop="col.prop">
                  <slot v-bind="{row: dataSource[activeIndex], $index: activeIndex}" :name="col.prop">
                    <el-input v-model="dataSource[activeIndex][col.prop]"></el-input>
                  </slot>
              </el-form-item>
            </el-form>
          </div>
        </l-drawer>
        <pasteDg ref="pasteDg" :rowKey="rowKey" :columns="columns" :title="title" @save="handlePaste"></pasteDg>
    </div>
</template>
<script>
import tableEvent from '@util/tableEvent';
import dynamicColumn from "./dynamic-column";
import pasteDg from './pasteDg'
export default {
  name:'l-edit-table',
  components:{
    dynamicColumn,
    pasteDg
  },
  mixins: [tableEvent()],
  props: {
    columns:{
      type: Array,
      default: () => []
    },
    columnsType: {
      type: String,
      default: "",
    },
    dataSource:{
      type: Array,
      default: () => []
    },
    height:{
      type:[String,Number]
    },
    maxHeight:{
      type:[String,Number]
    },
    stripe:{
      type:Boolean,
      default: false
    },
    border:{
      type:Boolean,
      default: false
    },
    fit:{
      type:Boolean,
      default: true
    },
    showHeader:{
      type:Boolean,
      default: true
    },
    highlightCurrentRow:{
      type:Boolean,
      default: false
    },

    currentRowKey:[String,Number],
    rowKey:[String,Function],

    rowClassName:[String,Function],
    cellClassName:[String,Function],
    headerRowClassName:[String,Function],
    headerCellClassName:[String,Function],

    defaultExpandAll:Boolean,
    expandRowKeys:{
      type: Array
    },

    defaultSort:Object,

    tooltipEffect:String,

    showSummary:{
      type:Boolean,
      default: false
    },
    sumText:{
      type:String,
      default: "合计"
    },
    summaryMethod:Function,

    spanMethod:Function,

    selectOnIndeterminate:{
      type:Boolean,
      default: true
    },

    indent:{
      type:Number,
      default: 16
    },
    lazy:Boolean,
    load:Function,
    treeProps:Object,

    isShowNum:{
      type:Boolean,
      default: true
    },
    isMultiSelect:Boolean,


    addBtnText:{
      type:String,
      default:'新增一行'//新增一行
    },
    isAddBtn:{
      type:Boolean,
      default:true
    },
    isRemoveBtn:{
      type:Boolean,
      default:true
    },
    isDetailBtn:{
      type:Boolean,
      default:false
    },
    required:{
      type:Boolean,
      default:false
    },
    isRead:{
      type:Boolean,
      default:false
    },
    filterDeleteBtn:Function,
    title: '',
    rows: {
      default: 0 // 默认展示行数
    },
    pasteAdd: {
      default: false // 是否支持粘贴新增
    },
    insertLine: {
      default: false // 支持向上向下插入空白行
    },
    printMode: {
      default: false 
    },
    detailUrl: {
      default: ''
    }
  },
  data () {
    return {
      isFullScreen: false,
      delMode: false, // 是否批量删除模式
      selected: [],
      showTable: true,
      visible: false,
      activeIndex: 0,
      editForm: {},
      rules: {}
    }
  },
  watch: {
    delMode(val) {
      // if (val) {
        this.showTable = false
        this.$nextTick(() => {
          this.showTable = true
        })
      // } else {
      //   this.$refs.learunTable.doLayout();
      // }
    },
    activeIndex() {
      this.$nextTick(() => {
        this.editForm = this.dataSource[this.activeIndex]
      })
    },
  },
  created () {
    if (!this.dataSource.length) {
      let rows = this.rows || 0
      if (rows > 0) for (let i = 0;i < rows;i++) {
        this.$emit('addRow');
      }
    }
  },
  computed:{
    dataSourceShow(){
      return this.dataSource.filter(t=>!t.isHide)
    },
    arrayColumns() {
      // 列的数据结构是树形结构，方便处理需要转成数组结构
      // if (this.columnsType == "tree") {
        return this.$toArray(this.columns);
      // } else {
      //   return this.columns;
      // }
    },
    tableColumns() {
      if (this.arrayColumns.length == 0) {
        return [{ label: "", prop: "learun_null", minWidth: "1" }];
      }
      return this.$toTree(this.arrayColumns);
    },
  },
  methods:{
    handleDetail(index, row) {
      let url = this.detailUrl || ''
      console.log(row, 'row-----------')
      for (let key in row) {
        url = url.replace(`{${key}}`, row[key])
      }
      var newWindow = window.open(`${location.origin}${url}`, '_blank')
      // 尝试断开新窗口与当前窗口的关联，防止新窗口操作当前窗口
      if (newWindow) {
          var newWindow = newWindow.opener = null;
      }
      
    },
    handlePasteAdd() {
      this.$refs.pasteDg.show();
    },
    toEdit(index, row) {
      !this.visible && (this.visible = true)
      this.activeIndex = index
    },
    prev() {
      this.activeIndex = this.activeIndex - 1
    },
    next() {
      this.activeIndex = this.activeIndex + 1
    },
    selectionChange(res) {
      this.selected = res
    },
    delSelected() {
      this.selected.forEach(e => {
        let index = this.dataSourceShow.indexOf(e)
        this.$emit('deleteRow',{index:index,row:e});
      })
    },
    toFullScreen() {
      this.isFullScreen = true;
    },
    getSummaryMethod (param) {
      const { columns, data } = param;
      const sums = [];
    
      function getDecimalPlaces(num) {
        const str = num.toString();
        if (str.indexOf('.') !== -1) {
          return str.split('.')[1].length;
        }
        return 0;
      }
      columns.forEach((column, index) => {
        const col = this.columns.find(e => e.prop === column.property);
        if (col && col.summaryType) {
          const values = data.map(item => item[column.property]*1).filter(value => !isNaN(value));
          console.log(values, 'values----------')
          console.log(data, 'data----------')
          if (values.length > 0) {
            let maxFix = 0
            let total = values.reduce((acc, val) => {
              console.log(acc, 'acc------------')
              console.log(val, 'val------------')
              console.log(getDecimalPlaces(acc), 'getDecimalPlaces(acc)------------')
              console.log(getDecimalPlaces(val), 'getDecimalPlaces(val)------------')
              let fix = Math.max(getDecimalPlaces(acc), getDecimalPlaces(val));
              console.log(fix, 'fix------------')
              if (fix > 0) {
                if (fix > maxFix) maxFix = fix
                acc = acc*10**fix, val = val*10**fix
                return (((acc + val) / (10**fix)).toFixed(maxFix))*1;
              }
              return acc + val
            }, 0);
            if (col.summaryType === '平均值') {
              const avg = total / values.length;
              // 使用 toPrecision 方法来根据数值大小自动调整小数位
              sums[index] = avg.toPrecision(avg < 1 || avg % 1 !== 0 ? undefined : 1);
            } else {
              // 对于总和，如果要求不固定小数位，通常不需要特殊处理
              sums[index] = total;
            }
            sums[index] = (sums[index].toFixed(maxFix))*1
          } else {
            sums[index] = '';
          }
        } else {
          sums[index] = '';
        }
      });
    
      return sums;
    },
    indexMethod(index) {
      return index +1;
    },
    handleDelete(index,row){
      this.$emit('deleteRow',{index:index,row:row});
      this.doLayout()
    },
    handleAdd(){
      this.$emit('addRow');
      this.doLayout()
    },
    handleCommand({type, row, index}) {
        let obj = {
          type: 'insert',
          index,
          row: this.$deepClone(row)
        }
        switch (type) {
          case 'copyToNext': 
            if (obj.row[this.rowKey]) {obj.row[this.rowKey] = Date.now() + Math.ceil(Math.random() * 99999)}
            obj.index++
            break;
          case 'copyToLast':
            if (obj.row[this.rowKey]) {obj.row[this.rowKey] = Date.now() + Math.ceil(Math.random() * 99999)}
            obj.index = this.dataSourceShow.length
            break;
          case 'insertToPrev':
            obj.row = null
            obj.index--
            break;
          case 'insertToNext':
            obj.index++
            obj.row = null
            break;
          default:
            break;
        }
        this.$emit('updateData', obj)
        this.doLayout()
    },
    handlePaste(list) {
      this.$emit('updateData', {
        type: 'pasteAdd',
        list
      })
    },
    doLayout() {
      this.$nextTick(() => {
        this.$refs.learunTable.doLayout();
      })
    },
    addNewForm() {
      this.handleAdd();
      if (!this.insertLine) return
      this.$nextTick(() => {
        this.activeIndex = this.dataSourceShow.length - 1
      })
    },
    addCopyForm() {
      this.handleCommand({
        type: 'copyToLast',
        index: this.dataSourceShow.length,
        row: this.$deepClone(this.dataSourceShow[this.activeIndex])
      })
      this.$nextTick(() => {
        this.activeIndex = this.dataSourceShow.length - 1
      })
    },
    hasDeleteBtn(row){
      if(this.filterDeleteBtn){
        return this.filterDeleteBtn(row)
      }
      else {
        return true;
      }
    },
    isRequired(property){
      let myColumn = this.columns.find(t=>t.prop == property)
      if(!myColumn){
        return false
      }
      return myColumn.required
    },
    validate(){
      let res = true
      if(this.required){
        if(this.dataSourceShow.length == 0){
          this.$message({
              type: 'error',
              message: this.$t(`${this.title || '表格' }需要添加数据！`)
          })
          return false
        }
      }
      try {
        this.dataSourceShow.forEach((row,index) => {
          this.columns.forEach(col=>{
            if(!col.isHidden){
              if(col.required && this.$validatenull(row[col.prop])){
                this.$message({
                    type: 'error',
                    message:`${this.$t('请输入')}#${index + 1}.${this.$t(col.label)}`
                })
                res = false
                throw new Error()
              }

              if(col.patterns && col.patterns.length > 0){
                col.patterns.forEach(pattern=>{
                    if(pattern.reg && !this.$validatenull(row[col.prop]) && !new RegExp(pattern.reg.substring(1,pattern.reg.length-1)).test(row[col.prop])){
                      this.$message({
                          type: 'error',
                          message: `${this.$t(pattern.msg)}#${index + 1}.${this.$t(col.label)}`
                      })
                      res = false
                      throw new Error()
                    }
                })
              }
            }
          })
        })
      } catch (error) {
        console.log(error, 'error----')
      }
      return res
    }
  }
}
</script>
<style lang="less">
.flex {
  display: flex;
  align-items: center;
}
  @import './index.less';
  // ::v-deep {
    .el-table__row {
      &:hover {
        .num-hide {
          display: flex;
        }
        .num-show {
          display: none;
        }
      }
    }
  // }
  .fullscreen {
    position: fixed !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 999;
  }
  .num-hide {
    display: none;
    align-items: center;
    justify-content: center;
  }
  .l-edit-table {
    .el-button--text{
        width: auto !important;
    }
    &:hover {
      .num-box {
        display: block;
      }
      .num-box-hide {
        display: none;
      }
    }
    .num-box {
      height: 25px;
      display: none;
    }
    .btn {
      padding: 6px;
      &:hover {
        cursor: pointer;
        color: #0d68ff;
      }
    }
  }
  
</style>
